import React from 'react';
import { Truck, Percent, Zap, Trophy } from 'lucide-react';

const tiles = [
  {
    Icon: Trophy,
    stat: 'Unlock',
    title: 'Prime & F-Assured Badge',
    desc: 'Store inventory at Amazon FBA / Flipkart FBF fulfilment centres in each state. Auto-qualify for the badge that boosts conversion by up to 3×.',
  },
  {
    Icon: Percent,
    stat: 'Save 50%',
    title: 'On Inter-state Shipping',
    desc: 'Convert costly IGST inter-state shipments into local CGST + SGST deliveries. Lower logistics cost, higher margin per order.',
  },
  {
    Icon: Zap,
    stat: '1-Day',
    title: 'Same-day Delivery',
    desc: 'Localise stock in North, South, West and East India. Serve every Tier-1 metro within 24 hours — customers convert faster.',
  },
  {
    Icon: Truck,
    stat: '12×',
    title: 'Buy Box & Reach',
    desc: 'Amazon and Flipkart algorithms prefer sellers with multi-state presence. More FCs = higher Buy Box share = more sales.',
  },
];

const GrowthROI = () => (
  <section className="bg-[#FAF2E8] py-16 md:py-20" data-testid="growth-roi">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="max-w-2xl">
        <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">Why VPOB + APOB</div>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 leading-[1.1]">
          Top e-commerce sellers use VPOB to
          <span className="relative inline-block ml-2 text-[#F39200]">
            grow, not just comply
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 400 10" fill="none">
              <path d="M2 7 C 100 1, 240 1, 398 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h2>
        <p className="mt-5 text-[15px] text-neutral-600 max-w-xl">
          Virtual office isn&apos;t just a compliance box. It&apos;s the fastest way to unlock revenue on Amazon, Flipkart, Meesho, JioMart and Myntra.
        </p>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {tiles.map(({ Icon, stat, title, desc }) => (
          <div key={title} className="group bg-white rounded-2xl border border-black/5 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all">
            <div className="w-12 h-12 rounded-xl bg-[#F39200]/10 text-[#F39200] flex items-center justify-center">
              <Icon size={22} />
            </div>
            <div className="mt-5 text-3xl font-extrabold text-neutral-900 leading-none">{stat}</div>
            <div className="mt-1 text-[15px] font-semibold text-neutral-900">{title}</div>
            <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GrowthROI;
